/**
 * zoneCheck.
 *
 * @param arrayXY
 * @returns boolean
 */
export function zoneCheck(
/** points */
arrayXY) {
    let { x, y } = arrayXY;
    if (x.length !== y.length) {
        return false;
    }
    return true;
}
//# sourceMappingURL=zoneCheck.js.map